import React, { useState } from 'react'
import axios from 'axios';
import { useEffect } from 'react'
import DefaultPage from '../../Components/DefaultPage';
import RightSidebarGlobal from '../../Components/RightSidebarGlobal';

import {
  DownloadOutlined,
  LeftOutlined,
  RightOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  UndoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from '@ant-design/icons';
import { Image, Space, Tabs } from 'antd';
import { BASE_URL } from '../../routes/config';
import FooterCus from '../../Components/FooterCus';
import Loader from '../../Components/Loader';


function GalleryPage() {


  // console.log(msg.cata_1, 'ddddddddddddddddd', msg.cata_2);


  const [current, setCurrent] = React.useState(0);
  const [getGalleryImage, setGalleryImage] = useState([]);
  const [getGalleryFolder, setGalleryFolder] = useState('');
  const [getPageTitle, setPageTitle] = useState('');
  const [loading, setLoading] = useState(true);



  const fetchdata = (cat_id) => {
    console.log(cat_id, 'cat_idcat_idcat_id');

    setLoading(true);

    const cread = {
      category: cat_id
    }

    // axios.post(`${BASE_URL}/wapi/gallimglist`, cread,
    axios.post(`${BASE_URL}/wapi/getimagelst`, cread,
      {
        auth_key: "xxxxx",
      }
      // ,
      // {
      //     headers: {
      //         Authorization: loginData.token,
      //     },
      // }
    ).then(res => {
      console.log('gggggggg', res?.data, 'kkkkkkkk', res.data.suc);
      setPageTitle('Gallery');
      if (res?.data?.suc > 0) {


        setGalleryImage(res?.data?.msg);
        // setGalleryFolder(res?.data?.folder);
        setGalleryFolder('gallery');

        setLoading(false);
        // setFolderLocation()


        // pageDataCheck = res.data.status;


      } else {
        setGalleryImage([])
        // pageDataCheck = res.data.status;
        setLoading(false);

      }

    })

  }

  const onDownload = () => {
    // const url = getGalleryImage[current];
    const currentImageObj = getGalleryImage[current];
    const url = `${BASE_URL}/${getGalleryFolder}/${currentImageObj.gal_img}`;
    const suffix = url.slice(url.lastIndexOf('.'));
    const filename = Date.now() + suffix;




    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        // console.log(url, 'jjjjjjjjjjj');
        const blobUrl = URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(blobUrl);
        link.remove();
      });
  };


  const onChange = key => {
    const selectedTab = items.find(item => item.key === key);
    fetchdata(selectedTab?.cat);
  };
  const items = [
    {
      key: '0',
      cat: '0',
      label: 'All Images',
      // children:'ffff',
    },
    {
      key: '1',
      cat: '1',
      label: 'Agri Input/Fertilizer',
      // children:'ffff',
    },
    {
      key: '2',
      cat: '2',
      label: 'Agri Marketing / Procurement',
      // children: 'fdgfdhfgh',
    },
    {
      key: '3',
      cat: '3',
      label: 'Accounting',
      // children: 'Content of Tab Pane 3',
    },
    {
      key: '4',
      cat: '4',
      label: 'Warehouse',
      // children: 'Content of Tab Pane 3',
    },
    {
      key: '5',
      cat: '5',
      label: 'Engineering',
      // children: 'Content of Tab Pane 3',
    },
  ];

  useEffect(() => {
    fetchdata(0);
  }, [])



  return (
    <>

      <div className="wrapper">
        <div className="inner_page_Sec">
          <div className="col-sm-8 float-left left_sec searchPageTop galleryPage">

            <h1>{getPageTitle}</h1>

            {/* <Tabs defaultActiveKey="0" items={items} onChange={onChange} /> */}

            <Tabs defaultActiveKey="0" onChange={onChange}>
              {items.map((item) => (
                <Tabs.TabPane tab={item.label} key={item.key}>

                  {getGalleryImage && getGalleryImage.length > 0 ? (
                    // ✅ IF there are images
                    <>
                    {/* {JSON.stringify(getGalleryImage, null, 2)} */}

                      <div className='thumbnail_image_sec row'>
                        {/* <Image.PreviewGroup
                          preview={{
                            toolbarRender: (
                              _,
                              {
                                transform: { scale },
                                actions: {
                                  onActive,
                                  onFlipY,
                                  onFlipX,
                                  onRotateLeft,
                                  onRotateRight,
                                  onZoomOut,
                                  onZoomIn,
                                  onReset,
                                },
                              },
                            ) => (
                              <Space size={12} className="toolbar-wrapper">

                                <DownloadOutlined onClick={onDownload} />
                                <SwapOutlined rotate={90} onClick={onFlipY} />
                                <SwapOutlined onClick={onFlipX} />
                                <RotateLeftOutlined onClick={onRotateLeft} />
                                <RotateRightOutlined onClick={onRotateRight} />
                                <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
                                <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
                                <UndoOutlined onClick={onReset} />
                              </Space>
                            ),
                            onChange: (index) => {
                              setCurrent(index);

                            },
                          }}
                        >

                          {getGalleryImage.map((item) => (
                            <div className='gal_thum'>
                              <Image key={item.gal_img} src={`${BASE_URL}/${getGalleryFolder}/${item.gal_img}`} width={200} />
                            </div>



                          ))}
                        </Image.PreviewGroup> */}

                        <Image.PreviewGroup
  preview={{
    imageRender: (originalNode, info) => {
  const currentImage = getGalleryImage[info.current];
  // console.log(getGalleryImage[info.current]?.cat_desc, 'Current Image Object:', currentImage); // Check this in your browser's console
  
  return (
    <div style={{ textAlign: 'center' }}>
      {/* <div style={{ maxWidth: 700, maxHeight: 500, margin: '0 auto' }}>
        {React.cloneElement(originalNode, { style: { maxWidth: '100%', maxHeight: '100%' } })}
      </div> */}

      <div
  style={{
    width: 600,
    height: 500,
    margin: "0 auto",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
  }}
>
  <div className='gal_main'>
  {React.cloneElement(originalNode, {
    style: {
      width: "100%",
      height: "500px",
      objectFit: "contain",   // << THIS CROPS THE IMAGE
    },
  })}

  {/* {originalNode} */}
      <div className='popup_img_gal_txt'>
        {currentImage?.narration || ''}
      </div>

      </div>

</div>

      
    </div>
  );
},

    // Keep your other preview toolbar features here
    toolbarRender: (
      _,
      {
        transform: { scale },
        actions: {
          onActive,
          onFlipY,
          onFlipX,
          onRotateLeft,
          onRotateRight,
          onZoomOut,
          onZoomIn,
          onReset,
        },
      },
    ) => (
      <Space size={12} className="toolbar-wrapper">
        <DownloadOutlined onClick={onDownload} />
        <SwapOutlined rotate={90} onClick={onFlipY} />
        <SwapOutlined onClick={onFlipX} />
        <RotateLeftOutlined onClick={onRotateLeft} />
        <RotateRightOutlined onClick={onRotateRight} />
        <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
        <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
        <UndoOutlined onClick={onReset} />
      </Space>
    ),
    onChange: (index) => {
      setCurrent(index);
    },
  }}
>
  {getGalleryImage.map((item) => (
    <div className='gal_thum'>
      <Image
        key={item.gal_img}
        src={`${BASE_URL}/${getGalleryFolder}/${item.gal_img}`}
        width={200}
        alt={item.gal_desc || 'Image'}
      />
    </div>
  ))}
</Image.PreviewGroup>



                      </div>
                    </> // Replace with your image rendering JSX
                  ) : (
                    <div>No images available</div> // Replace with your fallback UI
                  )}


                </Tabs.TabPane>
              ))}
            </Tabs>




            {/* {loading ? (
              <Loader align={'center'} gap={'middle'} size={'large'} />
            ) : (
              <>
                
    <h1>{getPageTitle}</h1>

                <div className='thumbnail_image_sec row'>
                  <Image.PreviewGroup
                    preview={{
                      toolbarRender: (
                        _,
                        {
                          transform: { scale },
                          actions: {
                            onActive,
                            onFlipY,
                            onFlipX,
                            onRotateLeft,
                            onRotateRight,
                            onZoomOut,
                            onZoomIn,
                            onReset,
                          },
                        },
                      ) => (
                        <Space size={12} className="toolbar-wrapper">

                          <DownloadOutlined onClick={onDownload} />
                          <SwapOutlined rotate={90} onClick={onFlipY} />
                          <SwapOutlined onClick={onFlipX} />
                          <RotateLeftOutlined onClick={onRotateLeft} />
                          <RotateRightOutlined onClick={onRotateRight} />
                          <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
                          <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
                          <UndoOutlined onClick={onReset} />
                        </Space>
                      ),
                      onChange: (index) => {
                        setCurrent(index);

                      },
                    }}
                  >

                    {getGalleryImage.map((item) => (
                      <div className='gal_thum'>
                        <Image key={item.gal_img} src={`${BASE_URL}/${getGalleryFolder}/${item.gal_img}`} width={200} />
                      </div>



                    ))}
                  </Image.PreviewGroup>

                </div>
              </>
            )} */}




          </div>
          <div class="col-sm-4 float-left">
            <RightSidebarGlobal />
          </div>

        </div>
      </div>

      {/* <DefaultPage pageTitle={pageContentData.pageTitle} pageContent = {pageContentData.pageContent} /> */}

      {/* <FooterCus/> */}

    </>
  )
}

export default GalleryPage